import { render, staticRenderFns } from "./FiltersAccordion.vue?vue&type=template&id=7a85a538&scoped=true&"
import script from "./FiltersAccordion.vue?vue&type=script&lang=js&"
export * from "./FiltersAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FiltersAccordion.vue?vue&type=style&index=0&id=7a85a538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a85a538",
  null
  
)

export default component.exports